import Vue from 'vue';
import { api } from "../../services/Api.js";

export function set_push_config({ state, commit }, payload ){

    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return new Promise( (resolve)=>{

      // make api call
      api
        .post(school,"set_push_config.php",payload)
        .then( () =>{ 
          //done
        
          commit('SET_PUSH_CONFIG',payload);
          resolve();
        })
        .catch( error => {
          Vue.$toaster.toast("store: set_push_config: "+error);
          
        })

    })

  }